import axios from 'axios';
import appConfig from '@/config';
import { getCookie } from '@/utils/auth/authService';
const BASE_URL = appConfig.api.base;

export function uploadFile(file, filename){
  const url = `${BASE_URL}/file/upload/`;
  let token = getCookie('token');
  const timestamp = new Date().getTime().toString();
  const formData = new FormData();
  formData.append(filename, file)
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':token,
      'X-Timestamp': timestamp,
      'X-File-Name': filename
    },
   data: formData
  })

}




// WEBPACK FOOTER //
// ./src/utils/upload/fileUpload.js